<template>
  <div id="month-yield-chart"></div>
</template>

<script>
  import d3 from 'd3'
  import c3 from 'c3'

  export default {
    name: 'month-yield-chart',
    props: {
      value: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    data: function () {
      return {
      }
    },
    computed: {
    },
    methods: {
      init: function () {
        const monthYield = this.value.simulate.month_yield

        // 월별 발전량 그래프
        let chart = {
          bindto: '#month-yield-chart',
          data: {
            x: 'x',
            columns: [
              ['x'].concat(['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']),
              ['발전량'].concat(monthYield)
            ],
            type: 'bar'
          },
          axis: {
            x: {
              type: 'category',
              tick: {
                fit: true,
                centered: true,
                multiline: false
              }
            },
            y: {
              label: {
                text: '(kWh)'
              }
            }
          },
          bar: {
            // width: 10
          },
          grid: {
            y: {
              show: true
            }
          },
          regions: [],
          color: {
            pattern: ['#9fbbd7']
          },
          tooltip: {
            format: {
              value: function (value) {
                // 3자리 단위 콤마 처리
                return d3.format(',')(value) + 'kWh'
              }
            }
          }
        }

        // 차트 초기화
        c3.generate(chart)
      }
    },
    created: function () {
    },
    mounted: function () {
      this.init()
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/chart/MonthYieldChart.vue